import { type FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Flex, Text } from "@chakra-ui/react";
import { useIsOn } from "~/hooks/featureFlags/useIsOn";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { NavItemWrapper } from "./NavItemWrapper";
import { type NavItemProps } from "./types";
import { getIsActive } from "./utils";

export const BasicNavItem: FC<NavItemProps> = ({
  bottom,
  children,
  featureFlag,
  href,
  left,
  onClick,
  right,
  state,
  to,
}) => {
  const user = useCurrentUser();
  const location = useLocation();
  const isOn = useIsOn(featureFlag);

  if (!isOn) {
    return null;
  }

  if (to) {
    const currentPath = location.pathname;
    const isSignedIn = !!user;
    const isActive = getIsActive(currentPath, to);

    return (
      <Link
        onClick={onClick}
        reloadDocument={!isSignedIn}
        state={state}
        style={{ padding: 0 }}
        to={to}
      >
        <Flex direction="column">
          <Flex align="center">
            {left}
            <NavItemWrapper isActive={isActive}>{children}</NavItemWrapper>
            {right}
          </Flex>
          {bottom}
        </Flex>
      </Link>
    );
  }

  if (href) {
    return (
      <Text
        as="a"
        href={href}
        onClick={onClick}
        style={{ padding: 0 }}
        target="_blank"
      >
        <Flex direction="column">
          <Flex align="center">
            {left}
            <NavItemWrapper>{children}</NavItemWrapper>
            {right}
          </Flex>
          {bottom}
        </Flex>
      </Text>
    );
  }

  return (
    <Flex
      align="center"
      color="th.black"
      justify={right ? "space-between" : "flex-start"}
      w="full"
    >
      {left}
      <NavItemWrapper onClick={onClick}>{children}</NavItemWrapper>
      {right}
    </Flex>
  );
};
